import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-games-page',
  templateUrl: './games-page.component.html',
  styleUrls: ['./games-page.component.scss'],
})
export class GamesPageComponent {
  populations = Populations;
  gameCards: any[] = [
    {
      title: 'Polls',
      description: 'Vote, test your knowledge, and compare opinions. ',
      buttonLabel: 'Vote',
      route: 'games/polls',
      image: 'assets/images/games/polls-image.jpg',
    },
  ];

  constructor(private router: Router) {}

  navigateByURL(route: string) {
    this.router.navigateByUrl(route);
  }
}
